import React from "react";
import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return  [
    {
      name: 'id',
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "报名名称",
      name: "name",
      searchItem: {},
      tableItem: {
        width: 200,
      }
    },
    // {
    //   title: "报名状态",
    //   name: "status",
    //   searchItem: {
    //     type: "select"
    //   },
    //   dict: [
    //     {code: 0, codeName: "草稿"},
    //     {code: 1, codeName: "报名中"},
    //     {code: 2, codeName: "已取消"},
    //     {code: 3, codeName: "已关闭"},
    //   ]
    // },
    {
      title: '报名时间',
      name: 'applyDate',
      dataIndex: "applyDate",
      tableItem: {
        width: 300,
        align: 'center',
        render: (text, record) => {
          const {startTime, endTime} = record;
          let applyDate = formatterDate(startTime) + " ~" + formatterDate(endTime);
          return applyDate
        }
      },
      searchItem: {
        type: 'date~',
        showTime: false,
        format: 'YYYY-MM-DD'
      },
    },
    {
      title: "安排类型",
      name: "planType",
      tableItem: {
        width: 120,
      },
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 0, codeName: "公共"},
        {code: 1, codeName: "班级"},
        // {code:2,codeName:"活动"},
      ]
    },
    {
      title: "报名人次",
      name: "number",
      tableItem: {
        width: 100,
      }
    },
    {
      title: "通过人次",
      name: "passNumber",
      tableItem: {
        width: 100,
      }
    },
    {
      title: "报名状态",
      name: "status",
      tableItem: {
        width: 100,
      },
      dict: [
        {code: 0, codeName: "草稿"},
        {code: 1, codeName: "报名中"},
        {code: 2, codeName: "已取消"},
        {code: 3, codeName: "已关闭"},
      ]
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'apply/listByPage',
    ...api
  }
}

const apply = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'name',
    columns: columns(),
    tableApi: tableApi(api),
    searchProps: {
      dataFormat: (v) => {
        let value = Object.assign([], v)
        if (value['applyDate'] && value['applyDate'].length === 2) {
          value['startDate'] = moment(value['applyDate'][0]).format("YYYY-MM-DD HH:mm:00")
          value['endDate'] = moment(value['applyDate'][1]).format("YYYY-MM-DD HH:mm:59")
        }
        delete value['applyDate']

        return value
      }
    },
  }
}

export default apply
